import React from "react";
import { SectionCard } from "../../components/ui";
import TroopInputList from "./TroopInputList";

const ArmySetupPanel = ({
  title,
  troopDefinitions,
  values,
  limits,
  currentTroopTotal,
  onChange,
  onZombieLimitChange,
  onTroopLimitChange,
  onReset,
  onApplyPreset,
  rowOrder,
  rowLabels,
  tierByTroop,
  tierOptionsByTroop,
  tierOptionLabelsByTroop,
  levelByTroop,
  levelOptionsByTroop,
  levelOptionLabelsByTroop,
  onTierChange,
  onLevelChange,
  selectedTierMetaByTroop,
  commanderCard,
}) => {
  return (
    <SectionCard className="army-setup-panel">
      <div className="army-setup-header">
        <h3>{title}</h3>
        <div className="army-setup-actions">
          <button type="button" onClick={() => onApplyPreset?.("basic")}>Basic Preset</button>
          <button type="button" onClick={() => onApplyPreset?.("midRange")}>Mid Preset</button>
          <button type="button" onClick={() => onApplyPreset?.("longRange")}>Long Preset</button>
          <button type="button" onClick={onReset}>Reset</button>
        </div>
      </div>

      {commanderCard ? (
        <div className="army-commander-slot">
          {commanderCard}
        </div>
      ) : null}

      <div className="army-limits-grid">
        <label className="army-limit-field">
          <span>Zombie Limit</span>
          <input
            type="text"
            inputMode="numeric"
            value={Number(limits?.zombieLimit ?? 0).toLocaleString()}
            onChange={(event) => onZombieLimitChange?.(event.target.value)}
          />
        </label>
        <label className="army-limit-field">
          <span>Fleet Size (units)</span>
          <input
            type="text"
            inputMode="numeric"
            value={Number(limits?.troopLimit ?? 0).toLocaleString()}
            onChange={(event) => onTroopLimitChange?.(event.target.value)}
          />
        </label>
      </div>

      <div className="army-limit-summary">
        Fleet Size Used (units, non-zombie):
        <strong>{Number(currentTroopTotal || 0).toLocaleString()}</strong>
        /
        <strong>{Number(limits?.troopLimit || 0).toLocaleString()}</strong>
      </div>

      <TroopInputList
        troopDefinitions={troopDefinitions}
        values={values}
        onChange={onChange}
        tierByTroop={tierByTroop}
        tierOptionsByTroop={tierOptionsByTroop}
        tierOptionLabelsByTroop={tierOptionLabelsByTroop}
        levelByTroop={levelByTroop}
        levelOptionsByTroop={levelOptionsByTroop}
        levelOptionLabelsByTroop={levelOptionLabelsByTroop}
        onTierChange={onTierChange}
        onLevelChange={onLevelChange}
        selectedTierMetaByTroop={selectedTierMetaByTroop}
        rowOrder={rowOrder}
        rowLabels={rowLabels}
      />
    </SectionCard>
  );
};

export default ArmySetupPanel;
